<template>
  <div v-loading="loading">
    <el-tabs v-model="activeName">
      <!-- Outdoor Temperature -->
      <el-tab-pane label="Outdoor" name="outdoor">
        <div style="margin-left: 300px">
          <h2>Outdoor Temperature: {{ outdoorForm.currentTemperature }}</h2>
        </div>
        <el-form ref="form" :model="outdoorForm" label-width="250px" @submit.prevent="onSubmit" style="margin: 20px; width: 60%; min-width: 600px">
          <!--Outdoor cannot be enabled or disabled-->
          <el-form-item label="Enabled">
            <el-checkbox v-model="outdoorForm.enabled" :disabled="true"></el-checkbox>
          </el-form-item>
          <el-form-item label="Calibration Adjustment">
            <el-input v-model="outdoorForm.calibrationAdjustment"></el-input>
          </el-form-item>
          <el-form-item label="Range High (20mA)">
            <el-input v-model="outdoorForm.rangeHigh"></el-input>
          </el-form-item>
          <el-form-item label="Range Low (4mA)">
            <el-input v-model="outdoorForm.rangeLow"></el-input>
          </el-form-item>
          <el-form-item style="margin-top: 10px">
            <el-button type="primary" style="margin-top: 10px" @click="saveDataToPanel">Save to Panel</el-button>
          </el-form-item>
        </el-form>
      </el-tab-pane>
      <el-tab-pane label="Domestic Water" name="domesticWater">
        <div style="margin-left: 300px">
          <h2>Domestic Water Temperature: {{ domesticForm.currentTemperature }}</h2>
        </div>
        <el-form ref="form" :model="domesticForm" label-width="250px" @submit.prevent="onSubmit" style="margin: 20px; width: 60%; min-width: 600px">
          <el-form-item label="Enabled">
            <el-checkbox v-model="domesticForm.enabled"></el-checkbox>
          </el-form-item>
          <el-form-item label="Calibration Adjustment" v-show="domesticForm.enabled">
            <el-input v-model="domesticForm.calibrationAdjustment"></el-input>
          </el-form-item>
          <el-form-item label="Range High (20mA)" v-show="domesticForm.enabled">
            <el-input v-model="domesticForm.rangeHigh"></el-input>
          </el-form-item>
          <el-form-item label="Range Low (4mA)" v-show="domesticForm.enabled">
            <el-input v-model="domesticForm.rangeLow"></el-input>
          </el-form-item>
          <el-form-item style="margin-top: 10px">
            <el-button type="primary" style="margin-top: 10px" @click="saveDataToPanel">Save to Panel</el-button>
          </el-form-item>
        </el-form>
      </el-tab-pane>
      <el-tab-pane label="Stack" name="stack">
        <div style="margin-left: 300px">
          <h2>Stack Temperature: {{ stackForm.currentTemperature }}</h2>
        </div>
        <el-form ref="form" :model="stackForm" label-width="250px" @submit.prevent="onSubmit" style="margin: 20px; width: 60%; min-width: 600px">
          <el-form-item label="Enabled">
            <el-checkbox v-model="stackForm.enabled"></el-checkbox>
          </el-form-item>
          <el-form-item label="Calibration Adjustment" v-show="stackForm.enabled">
            <el-input v-model="stackForm.calibrationAdjustment"></el-input>
          </el-form-item>
          <el-form-item label="Range High (20mA)" v-show="stackForm.enabled">
            <el-input v-model="stackForm.rangeHigh"></el-input>
          </el-form-item>
          <el-form-item label="Range Low (4mA)" v-show="stackForm.enabled">
            <el-input v-model="stackForm.rangeLow"></el-input>
          </el-form-item>
          <el-form-item style="margin-top: 10px">
            <el-button type="primary" style="margin-top: 10px" @click="saveDataToPanel">Save to Panel</el-button>
          </el-form-item>
        </el-form>
      </el-tab-pane>
      <el-tab-pane label="Return line" name="returnLine">
        <div style="margin-left: 300px">
          <h2>Return Line Temperature: {{ returnLineForm.currentTemperature }}</h2>
        </div>
        <el-form ref="form" :model="returnLineForm" label-width="250px" @submit.prevent="onSubmit" style="margin: 20px; width: 60%; min-width: 600px">
          <el-form-item label="Enabled">
            <el-checkbox v-model="returnLineForm.enabled" :disabled="returnLineForm.allowControlEnabled"></el-checkbox>
          </el-form-item>
          <el-form-item label="Calibration Adjustment" v-show="returnLineForm.enabled">
            <el-input v-model="returnLineForm.calibrationAdjustment"></el-input>
          </el-form-item>
          <el-form-item label="Range High (20mA)" v-show="returnLineForm.enabled">
            <el-input v-model="returnLineForm.rangeHigh"></el-input>
          </el-form-item>
          <el-form-item label="Range Low (4mA)" v-show="returnLineForm.enabled">
            <el-input v-model="returnLineForm.rangeLow"></el-input>
          </el-form-item>
          <el-form-item style="margin-top: 10px">
            <el-button type="primary" style="margin-top: 10px" @click="saveDataToPanel">Save to Panel</el-button>
          </el-form-item>
        </el-form>
      </el-tab-pane>
      <el-tab-pane label="Auxiliary" name="aux">
        <div style="margin-left: 300px">
          <h2>Auxiliary Temperature: {{ auxiliaryForm.currentTemperature }}</h2>
        </div>
        <el-form ref="form" :model="auxiliaryForm" label-width="250px" @submit.prevent="onSubmit" style="margin: 20px; width: 60%; min-width: 600px">
          <el-form-item label="Enabled">
            <el-checkbox v-model="auxiliaryForm.enabled"></el-checkbox>
          </el-form-item>
          <el-form-item label="Calibration Adjustment" v-show="auxiliaryForm.enabled">
            <el-input v-model="auxiliaryForm.calibrationAdjustment"></el-input>
          </el-form-item>
          <el-form-item label="Range High (20mA)" v-show="auxiliaryForm.enabled">
            <el-input v-model="auxiliaryForm.rangeHigh"></el-input>
          </el-form-item>
          <el-form-item label="Range Low (4mA)" v-show="auxiliaryForm.enabled">
            <el-input v-model="auxiliaryForm.rangeLow"></el-input>
          </el-form-item>
          <el-form-item style="margin-top: 10px">
            <el-button type="primary" style="margin-top: 10px" @click="saveDataToPanel">Save to Panel</el-button>
          </el-form-item>
        </el-form>
      </el-tab-pane>
      <el-tab-pane label="Heat Balancer" name="heatBalancer">
        <div style="margin-left: 50px" v-if="heatBalancerForm.enabled">
          <h2>Heat Balancer Difference: {{ heatBalancerForm.difference }}</h2>
        </div>
        <el-form ref="form" s :model="heatBalancerForm" label-width="100px" @submit.prevent="onSubmit" style="margin: 20px; width: 60%; min-width: 600px">
          <el-form-item label="Enabled">
            <el-checkbox v-model="heatBalancerForm.enabled" :disabled="heatBalancerForm.allowControlEnabled"></el-checkbox>
          </el-form-item>
        </el-form>
        <!--Heat Balancer top and bottom-->
        <el-tabs v-model="heatBalancerActiveName" v-if="heatBalancerForm.enabled">
          <el-tab-pane label="Top" name="top">
            <div style="margin-left: 300px">
              <h2>Heat Balancer Top: {{ heatBalancerForm.top.currentTemperature }}</h2>
            </div>
            <el-form ref="form" :model="heatBalancerForm.top" label-width="250px" @submit.prevent="onSubmit" style="margin: 20px; width: 60%; min-width: 600px">
              <el-form-item label="Calibration Adjustment">
                <el-input v-model="heatBalancerForm.top.calibrationAdjustment"></el-input>
              </el-form-item>
              <el-form-item label="Range High (20mA)">
                <el-input v-model="heatBalancerForm.top.rangeHigh"></el-input>
              </el-form-item>
              <el-form-item label="Range Low (4mA)">
                <el-input v-model="heatBalancerForm.top.rangeLow"></el-input>
              </el-form-item>
              <el-form-item style="margin-top: 10px">
                <el-button type="primary" style="margin-top: 10px" @click="saveDataToPanel">Save to Panel</el-button>
              </el-form-item>
            </el-form>
          </el-tab-pane>
          <el-tab-pane label="Bottom" name="bottom">
            <div style="margin-left: 300px">
              <h2>Heat Balancer Bottom: {{ heatBalancerForm.bottom.currentTemperature }}</h2>
            </div>
            <el-form ref="form" :model="heatBalancerForm.bottom" label-width="250px" @submit.prevent="onSubmit" style="margin: 20px; width: 60%; min-width: 600px">
              <el-form-item label="Calibration Adjustment">
                <el-input v-model="heatBalancerForm.bottom.calibrationAdjustment"></el-input>
              </el-form-item>
              <el-form-item label="Range High (20mA)">
                <el-input v-model="heatBalancerForm.bottom.rangeHigh"></el-input>
              </el-form-item>
              <el-form-item label="Range Low (4mA)">
                <el-input v-model="heatBalancerForm.bottom.rangeLow"></el-input>
              </el-form-item>
              <el-form-item style="margin-top: 10px">
                <el-button type="primary" style="margin-top: 10px" @click="saveDataToPanel">Save to Panel</el-button>
              </el-form-item>
            </el-form>
          </el-tab-pane>
        </el-tabs>
        <input style="color: white; outline: none; border: none" ref="hidden" />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import Axios from "axios"
import echarts from "echarts"
import IOService from "@/api/io.service"
import SettingsService from "@/api/settings.service"
import constants from "@/common/constants/system"
import Util from "@/common/js/util"

export default {
  data() {
    return {
      polling: null,
      loading: false,
      activeName: "outdoor",
      heatBalancerActiveName: "top",
      outdoorForm: {
        currentTemperature: "",
        enabled: false,
        calibrationAdjustment: "",
        rangeHigh: "",
        rangeLow: ""
      },
      domesticForm: {
        currentTemperature: "",
        enabled: false,
        calibrationAdjustment: "",
        rangeHigh: "",
        rangeLow: ""
      },
      stackForm: {
        currentTemperature: "",
        enabled: false,
        calibrationAdjustment: "",
        rangeHigh: "",
        rangeLow: ""
      },
      returnLineForm: {
        currentTemperature: "",
        enabled: false,
        allowControlEnabled: false,
        calibrationAdjustment: "",
        rangeHigh: "",
        rangeLow: ""
      },
      auxiliaryForm: {
        currentTemperature: "",
        enabled: false,
        calibrationAdjustment: "",
        rangeHigh: "",
        rangeLow: ""
      },
      heatBalancerForm: {
        enabled: false,
        allowControlEnabled: false,
        difference: "",
        top: {
          currentTemperature: "",
          calibrationAdjustment: "",
          rangeHigh: "",
          rangeLow: ""
        },
        bottom: {
          currentTemperature: "",
          calibrationAdjustment: "",
          rangeHigh: "",
          rangeLow: ""
        }
      },
      user: this.$session.get("User")
    }
  },
  mounted() {
    this.getData()
    this.getIOData()
    this.polling = setInterval(this.getIOData, 1000)
  },
  beforeDestroy() {
    clearInterval(this.polling)
  },
  methods: {
    notify(title) {
      const h = this.$createElement
      this.$notify({
        title: title,
        message: "Value not valid",
        type: "error"
      })
    },
    verifySettings() {
      if (isNaN(parseInt(this.outdoorForm.calibrationAdjustment)) || isNaN(parseInt(this.outdoorForm.rangeHigh)) || isNaN(parseInt(this.outdoorForm.rangeLow))) {
        this.notify("Outdoor Temperature")
        return false
      }
      if (isNaN(parseInt(this.domesticForm.calibrationAdjustment)) || isNaN(parseInt(this.domesticForm.rangeHigh)) || isNaN(parseInt(this.domesticForm.rangeLow))) {
        this.notify("Domestic Temperature")
        return false
      }
      if (isNaN(parseInt(this.stackForm.calibrationAdjustment)) || isNaN(parseInt(this.stackForm.rangeHigh)) || isNaN(parseInt(this.stackForm.rangeLow))) {
        this.notify("Stack Temperature")
        return false
      }
      if (isNaN(parseInt(this.returnLineForm.calibrationAdjustment)) || isNaN(parseInt(this.returnLineForm.rangeHigh)) || isNaN(parseInt(this.returnLineForm.rangeLow))) {
        this.notify("Retrun line Temperature")
        return false
      }
      if (isNaN(parseInt(this.auxiliaryForm.calibrationAdjustment)) || isNaN(parseInt(this.auxiliaryForm.rangeHigh)) || isNaN(parseInt(this.auxiliaryForm.rangeLow))) {
        this.notify("Aux Temperature")
        return false
      }
      if (isNaN(parseInt(this.heatBalancerForm.top.calibrationAdjustment)) || isNaN(parseInt(this.heatBalancerForm.top.rangeHigh)) || isNaN(parseInt(this.heatBalancerForm.top.rangeLow))) {
        this.notify("Heat Balancer Top Temperature")
        return false
      }
      if (isNaN(parseInt(this.heatBalancerForm.bottom.calibrationAdjustment)) || isNaN(parseInt(this.heatBalancerForm.bottom.rangeHigh)) || isNaN(parseInt(this.heatBalancerForm.bottom.rangeLow))) {
        this.notify("Heat Balancer Bottom Temperature")
        return false
      }
      return true
    },
    saveDataToPanel() {
      if (!this.verifySettings()) return
      switch (this.activeName) {
        case "outdoor":
          this.loading = true
          Axios.all([
            SettingsService.changeSetting(this.user.activeZone, "Settings.Sensors.Temperature.Outdoor.CalibrationAdjustment", this.outdoorForm.calibrationAdjustment),
            SettingsService.changeSetting(this.user.activeZone, "Settings.Sensors.Temperature.Outdoor.RangeHigh", this.outdoorForm.rangeHigh),
            SettingsService.changeSetting(this.user.activeZone, "Settings.Sensors.Temperature.Outdoor.RangeLow", this.outdoorForm.rangeLow)
          ])
            .then(
              Axios.spread((calibrationResponse, rangeHighResponse, rangeLowResponse) => {
                //The system should update in 10 seconds.
                this.loading = false
                if (calibrationResponse.data.result != "success" || rangeHighResponse.data.result != "success" || rangeLowResponse.data.result != "success") {
                  const h = this.$createElement
                  this.$notify({
                    title: "Outdoor Temperature Sensor Settings",
                    message: "Error trying to save data to panel",
                    type: "error"
                  })
                } else {
                  this.$notify({
                    title: "Outdoor Temperature Sensor Settings",
                    message: "Settings Saved to Panel",
                    type: "info"
                  })
                }
              })
            )
            .catch(() => {
              this.loading = false
              const h = this.$createElement
              this.$notify({
                title: "Outdoor Temperature Sensor Settings",
                message: "Error trying to save data to panel",
                type: "error"
              })
            })
          break
        case "domesticWater":
          this.loading = true
          Axios.all([
            SettingsService.changeSetting(this.user.activeZone, "Settings.Sensors.Temperature.Domestic.Enabled", this.domesticForm.enabled ? "true" : "false"),
            SettingsService.changeSetting(this.user.activeZone, "Settings.Sensors.Temperature.Domestic.CalibrationAdjustment", this.domesticForm.calibrationAdjustment),
            SettingsService.changeSetting(this.user.activeZone, "Settings.Sensors.Temperature.Domestic.RangeHigh", this.domesticForm.rangeHigh),
            SettingsService.changeSetting(this.user.activeZone, "Settings.Sensors.Temperature.Domestic.RangeLow", this.domesticForm.rangeLow)
          ])
            .then(
              Axios.spread((enabledResponse, calibrationResponse, rangeHighResponse, rangeLowResponse) => {
                //The system should update in 10 seconds.
                this.loading = false
                if (
                  enabledResponse.data.result != "success" ||
                  calibrationResponse.data.result != "success" ||
                  rangeHighResponse.data.result != "success" ||
                  rangeLowResponse.data.result != "success"
                ) {
                  const h = this.$createElement
                  this.$notify({
                    title: "Domestic Water Temperature Sensor Settings",
                    message: "Error trying to save data to panel",
                    type: "error"
                  })
                } else {
                  this.$notify({
                    title: "Domestic Water Temperature Sensor Settings",
                    message: "Settings Saved to Panel",
                    type: "info"
                  })
                }
              })
            )
            .catch(() => {
              this.loading = false
              const h = this.$createElement
              this.$notify({
                title: "Domestic Water Temperature Sensor Settings",
                message: "Error trying to save data to panel",
                type: "error"
              })
            })
          break
        case "stack":
          this.loading = true
          Axios.all([
            SettingsService.changeSetting(this.user.activeZone, "Settings.Sensors.Temperature.Stack.Enabled", this.stackForm.enabled ? "true" : "false"),
            SettingsService.changeSetting(this.user.activeZone, "Settings.Sensors.Temperature.Stack.CalibrationAdjustment", this.stackForm.calibrationAdjustment),
            SettingsService.changeSetting(this.user.activeZone, "Settings.Sensors.Temperature.Stack.RangeHigh", this.stackForm.rangeHigh),
            SettingsService.changeSetting(this.user.activeZone, "Settings.Sensors.Temperature.Stack.RangeLow", this.stackForm.rangeLow)
          ])
            .then(
              Axios.spread((enabledResponse, calibrationResponse, rangeHighResponse, rangeLowResponse) => {
                //The system should update in 10 seconds.
                this.loading = false
                if (
                  enabledResponse.data.result != "success" ||
                  calibrationResponse.data.result != "success" ||
                  rangeHighResponse.data.result != "success" ||
                  rangeLowResponse.data.result != "success"
                ) {
                  const h = this.$createElement
                  this.$notify({
                    title: "Stack Temperature Sensor Settings",
                    message: "Error trying to save data to panel",
                    type: "error"
                  })
                } else {
                  this.$notify({
                    title: "Stack Temperature Sensor Settings",
                    message: "Settings Saved to Panel",
                    type: "info"
                  })
                }
              })
            )
            .catch(() => {
              this.loading = false
              const h = this.$createElement
              this.$notify({
                title: "Stack Temperature Sensor Settings",
                message: "Error trying to save data to panel",
                type: "error"
              })
            })
          break
        case "returnLine":
          this.loading = true
          Axios.all([
            SettingsService.changeSetting(this.user.activeZone, "Settings.Sensors.Temperature.ReturnLine.Enabled", this.returnLineForm.enabled ? "true" : "false"),
            SettingsService.changeSetting(this.user.activeZone, "Settings.Sensors.Temperature.ReturnLine.CalibrationAdjustment", this.returnLineForm.calibrationAdjustment),
            SettingsService.changeSetting(this.user.activeZone, "Settings.Sensors.Temperature.ReturnLine.RangeHigh", this.returnLineForm.rangeHigh),
            SettingsService.changeSetting(this.user.activeZone, "Settings.Sensors.Temperature.ReturnLine.RangeLow", this.returnLineForm.rangeLow)
          ])
            .then(
              Axios.spread((enabledResponse, calibrationResponse, rangeHighResponse, rangeLowResponse) => {
                //The system should update in 10 seconds.
                this.loading = false
                if (
                  enabledResponse.data.result != "success" ||
                  calibrationResponse.data.result != "success" ||
                  rangeHighResponse.data.result != "success" ||
                  rangeLowResponse.data.result != "success"
                ) {
                  const h = this.$createElement
                  this.$notify({
                    title: "Return Line Temperature Sensor Settings",
                    message: "Error trying to save data to panel",
                    type: "error"
                  })
                } else {
                  this.$notify({
                    title: "Return Line Temperature Sensor Settings",
                    message: "Settings Saved to Panel",
                    type: "info"
                  })
                }
              })
            )
            .catch(() => {
              this.loading = false
              const h = this.$createElement
              this.$notify({
                title: "Return Line Temperature Sensor Settings",
                message: "Error trying to save data to panel",
                type: "error"
              })
            })
          break
        case "aux":
          this.loading = true
          Axios.all([
            SettingsService.changeSetting(this.user.activeZone, "Settings.Sensors.Temperature.Aux.Enabled", this.auxiliaryForm.enabled ? "true" : "false"),
            SettingsService.changeSetting(this.user.activeZone, "Settings.Sensors.Temperature.Aux.CalibrationAdjustment", this.auxiliaryForm.calibrationAdjustment),
            SettingsService.changeSetting(this.user.activeZone, "Settings.Sensors.Temperature.Aux.RangeHigh", this.auxiliaryForm.rangeHigh),
            SettingsService.changeSetting(this.user.activeZone, "Settings.Sensors.Temperature.Aux.RangeLow", this.auxiliaryForm.rangeLow)
          ])
            .then(
              Axios.spread((enabledResponse, calibrationResponse, rangeHighResponse, rangeLowResponse) => {
                //The system should update in 10 seconds.
                this.loading = false
                if (
                  enabledResponse.data.result != "success" ||
                  calibrationResponse.data.result != "success" ||
                  rangeHighResponse.data.result != "success" ||
                  rangeLowResponse.data.result != "success"
                ) {
                  const h = this.$createElement
                  this.$notify({
                    title: "Aux Temperature Sensor Settings",
                    message: "Error trying to save data to panel",
                    type: "error"
                  })
                } else {
                  this.$notify({
                    title: "Aux Temperature Sensor Settings",
                    message: "Settings Saved to Panel",
                    type: "info"
                  })
                }
              })
            )
            .catch(() => {
              this.loading = false
              const h = this.$createElement
              this.$notify({
                title: "Aux Temperature Sensor Settings",
                message: "Error trying to save data to panel",
                type: "error"
              })
            })
          break
        case "heatBalancer":
          this.loading = true
          Axios.all([
            SettingsService.changeSetting(this.user.activeZone, "Settings.Sensors.Temperature.HeatBalancer.Enabled", this.heatBalancerForm.enabled ? "true" : "false"),
            SettingsService.changeSetting(this.user.activeZone, "Settings.Sensors.Temperature.HeatBalancer.Top.CalibrationAdjustment", this.heatBalancerForm.top.calibrationAdjustment),
            SettingsService.changeSetting(this.user.activeZone, "Settings.Sensors.Temperature.HeatBalancer.Top.RangeHigh", this.heatBalancerForm.top.rangeHigh),
            SettingsService.changeSetting(this.user.activeZone, "Settings.Sensors.Temperature.HeatBalancer.Top.RangeLow", this.heatBalancerForm.top.rangeLow),
            SettingsService.changeSetting(this.user.activeZone, "Settings.Sensors.Temperature.HeatBalancer.Bottom.CalibrationAdjustment", this.heatBalancerForm.bottom.calibrationAdjustment),
            SettingsService.changeSetting(this.user.activeZone, "Settings.Sensors.Temperature.HeatBalancer.Bottom.RangeHigh", this.heatBalancerForm.bottom.rangeHigh),
            SettingsService.changeSetting(this.user.activeZone, "Settings.Sensors.Temperature.HeatBalancer.Bottom.RangeLow", this.heatBalancerForm.bottom.rangeLow)
          ])
            .then(
              Axios.spread((enabledResponse, topCalibrationResponse, topRangeHighResponse, topRangeLowResponse, bottomCalibrationResponse, bottomRangeHighResponse, bottomRangeLowResponse) => {
                //The system should update in 10 seconds.
                this.loading = false
                if (
                  enabledResponse.data.result != "success" ||
                  topCalibrationResponse.data.result != "success" ||
                  topRangeHighResponse.data.result != "success" ||
                  topRangeLowResponse.data.result != "success" ||
                  bottomCalibrationResponse.data.result != "success" ||
                  bottomRangeHighResponse.data.result != "success" ||
                  bottomRangeLowResponse.data.result != "success"
                ) {
                  const h = this.$createElement
                  this.$notify({
                    title: "Heat Balancer Temperature Sensor Settings",
                    message: "Error trying to save data to panel",
                    type: "error"
                  })
                } else {
                  this.$notify({
                    title: "Heat Balancer Temperature Sensor Settings",
                    message: "Settings Saved to Panel",
                    type: "info"
                  })
                }
              })
            )
            .catch(() => {
              this.loading = false
              const h = this.$createElement
              this.$notify({
                title: "Heat Balancer Temperature Sensor Settings",
                message: "Error trying to save data to panel",
                type: "error"
              })
            })
          break
      }
    },
    showNotification(data, _title, value, min, max) {
      if (data < min || data > max || data == "") {
        const h = this.$createElement
        this.$notify({
          title: _title,
          message: value + " should be betweeen " + min + " and " + max,
          type: "warning"
        })
        return false
      } else {
        return true
      }
    },
    getData() {
      //Axios.defaults.baseURL = 'http://192.168.137.233:3000';
      Axios.all([IOService.getSettings(this.user.activeZone)]).then(
        Axios.spread((settingsResponse) => {
          //Outdoor Temperature
          this.outdoorForm.enabled = settingsResponse.data.sensors.temperature.outdoor.enabled == "true"
          this.outdoorForm.calibrationAdjustment = settingsResponse.data.sensors.temperature.outdoor.calibrationAdjustment
          this.outdoorForm.rangeHigh = settingsResponse.data.sensors.temperature.outdoor.rangeHigh
          this.outdoorForm.rangeLow = settingsResponse.data.sensors.temperature.outdoor.rangeLow
          //Domestic Water
          this.domesticForm.enabled = settingsResponse.data.sensors.temperature.domesticWater.enabled == "true"
          this.domesticForm.calibrationAdjustment = settingsResponse.data.sensors.temperature.domesticWater.calibrationAdjustment
          this.domesticForm.rangeHigh = settingsResponse.data.sensors.temperature.domesticWater.rangeHigh
          this.domesticForm.rangeLow = settingsResponse.data.sensors.temperature.domesticWater.rangeLow
          //Stack
          this.stackForm.enabled = settingsResponse.data.sensors.temperature.stack.enabled == "true"
          this.stackForm.calibrationAdjustment = settingsResponse.data.sensors.temperature.stack.calibrationAdjustment
          this.stackForm.rangeHigh = settingsResponse.data.sensors.temperature.stack.rangeHigh
          this.stackForm.rangeLow = settingsResponse.data.sensors.temperature.stack.rangeLow
          //Return Line
          this.returnLineForm.enabled = settingsResponse.data.sensors.temperature.returnLine.enabled == "true"
          //We check if we can allow the user to enabled or disable
          if (settingsResponse.data.returnLine.enabled == "true") {
            this.returnLineForm.allowControlEnabled = true
          }

          this.returnLineForm.calibrationAdjustment = settingsResponse.data.sensors.temperature.returnLine.calibrationAdjustment
          this.returnLineForm.rangeHigh = settingsResponse.data.sensors.temperature.returnLine.rangeHigh
          this.returnLineForm.rangeLow = settingsResponse.data.sensors.temperature.returnLine.rangeLow
          //Auxiliary
          this.auxiliaryForm.enabled = settingsResponse.data.sensors.temperature.aux.enabled == "true"
          this.auxiliaryForm.calibrationAdjustment = settingsResponse.data.sensors.temperature.aux.calibrationAdjustment
          this.auxiliaryForm.rangeHigh = settingsResponse.data.sensors.temperature.aux.rangeHigh
          this.auxiliaryForm.rangeLow = settingsResponse.data.sensors.temperature.aux.rangeLow
          //Heat Balancer
          this.heatBalancerForm.enabled = settingsResponse.data.sensors.temperature.heatBalancer.enabled == "true"
          if (settingsResponse.data.heatBalancer.enabled == "true") this.heatBalancerForm.allowControlEnabled = true
          //Top
          this.heatBalancerForm.top.calibrationAdjustment = settingsResponse.data.sensors.temperature.heatBalancer.top.calibrationAdjustment
          this.heatBalancerForm.top.rangeHigh = settingsResponse.data.sensors.temperature.heatBalancer.top.rangeHigh
          this.heatBalancerForm.top.rangeLow = settingsResponse.data.sensors.temperature.heatBalancer.top.rangeLow
          //Bottom
          this.heatBalancerForm.bottom.calibrationAdjustment = settingsResponse.data.sensors.temperature.heatBalancer.bottom.calibrationAdjustment
          this.heatBalancerForm.bottom.rangeHigh = settingsResponse.data.sensors.temperature.heatBalancer.bottom.rangeHigh
          this.heatBalancerForm.bottom.rangeLow = settingsResponse.data.sensors.temperature.heatBalancer.bottom.rangeLow
        })
      )
    },
    getIOData() {
      //Axios.defaults.baseURL = 'http://192.168.137.233:3000';
      Axios.all([IOService.getIO(this.user.activeZone), IOService.getSettings(this.user.activeZone)]).then(
        Axios.spread((IOResponse, SettingsResponse) => {
          this.outdoorForm.currentTemperature = Util.printTemperature(IOResponse.data.sensors.temperature.outdoor.toFixed(1))
          this.domesticForm.currentTemperature = Util.printTemperature(IOResponse.data.sensors.temperature.domesticWater.toFixed(1))
          this.stackForm.currentTemperature = Util.printTemperature(IOResponse.data.sensors.temperature.stack.toFixed(1))
          this.returnLineForm.currentTemperature = Util.printTemperature(IOResponse.data.sensors.temperature.returnLine.toFixed(1))
          this.auxiliaryForm.currentTemperature = Util.printTemperature(IOResponse.data.sensors.temperature.aux.toFixed(1))
          this.heatBalancerForm.top.currentTemperature = Util.printTemperature(IOResponse.data.sensors.temperature.heatBalancer.top.toFixed(1))
          this.heatBalancerForm.bottom.currentTemperature = Util.printTemperature(IOResponse.data.sensors.temperature.heatBalancer.bottom.toFixed(1))
          this.heatBalancerForm.difference = Util.printTemperature((IOResponse.data.sensors.temperature.heatBalancer.top - IOResponse.data.sensors.temperature.heatBalancer.bottom).toFixed(1))
        })
      )
    }
  }
}
</script>

<style scoped>
.chart-container {
  width: 100%;
  float: left;
}
/*.chart div {
        height: 400px;
        float: left;
    }*/

.el-col {
  padding: 30px 20px;
}
</style>



// WEBPACK FOOTER //
// TemperatureSensors.vue?683d3601